$(document).ready(function() {
    // sort all home designs into memory
    const displayMapContainer = document.getElementById('display-homes-map');
    const houseAndLandContainer = document.getElementById('house-and-land-container');

    if (displayMapContainer) {
        var baseTop = null;
        $(window).scroll(function(){
            let mapContainer = $('.dh-map-container');
            let mapTop = mapContainer.offset().top;
            let isPositionFixed = mapContainer.css('position') === 'fixed';
            let cs = $('#CardWrapper');
            let belowBottomDiv = $(window).scrollTop() >= cs.offset().top + cs.outerHeight() - window.innerHeight;
            let aboveTopDiv = baseTop !== null && $(window).scrollTop() < baseTop;

            if ($(window).scrollTop() > mapTop && !isPositionFixed && !belowBottomDiv) {
                mapContainer.css({ position: 'fixed', top: 0, height: '100vh' });

                if (baseTop === null) {
                    baseTop = mapTop;
                }

            } else if ($(window).scrollTop() > !mapTop && !isPositionFixed && !belowBottomDiv) {
                mapContainer.css({ position: 'absolute', top: 0, height: '100vh' });

                if (baseTop === null) {
                    baseTop = mapTop;
                }

            }
            else if (isPositionFixed) {
                if (aboveTopDiv) {
                    mapContainer.css({ position: 'absolute', top: 0, height: '100vh', bottom: 'auto' });
                } else if (belowBottomDiv) {
                    mapContainer.css({ position: 'absolute', top: 'auto', height: '100vh', bottom: 0 });
                }
            } else if (!isPositionFixed) {
                if (aboveTopDiv) {
                    mapContainer.css({ position: 'absolute', top: 0, height: '100vh', bottom: 'auto' });
                }
            }
        });

        // Hide Map Button
        const cardWrapper = document.getElementById('CardWrapper');
        const displayHomesContainer = document.getElementById('display-homes-container');
        const mapWrapper = document.getElementById('MapWrapper');
        const hideMapBtn = document.getElementById('HideMapBtn');

        $(hideMapBtn).click(function () {
            if (hideMapBtn.classList.contains("map-hidden")) {
                hideMapBtn.innerHTML = "Hide Map";
                mapWrapper.classList.remove("uk-hidden");
                hideMapBtn.classList.remove("map-hidden");
                cardWrapper.classList.add("uk-width-1-2@s", "uk-width-2-5@m", "uk-width-2-3@l");
                displayHomesContainer.classList.remove("uk-child-width-1-2@s", "uk-child-width-1-3@l");
                displayHomesContainer.classList.add("uk-child-width-1-2@l");


            } else {
                hideMapBtn.innerHTML = "Show Map";
                mapWrapper.classList.add("uk-hidden");
                hideMapBtn.classList.add("map-hidden");
                cardWrapper.classList.remove("uk-width-1-2@s", "uk-width-2-5@m", "uk-width-2-3@l");
                displayHomesContainer.classList.remove("uk-child-width-1-2@l");
                displayHomesContainer.classList.add("uk-child-width-1-2@s", "uk-child-width-1-3@l");
            }
        })
    }

    if (houseAndLandContainer) {
        var baseTop = null;
        $(window).scroll(function(){
            let mapContainer = $('.hl-map-container');
            let mapTop = mapContainer.offset().top;
            let isPositionFixed = mapContainer.css('position') === 'fixed';
            let cs = $('#CardWrapper');
            let belowBottomDiv = $(window).scrollTop() >= cs.offset().top + cs.outerHeight() - window.innerHeight;
            let aboveTopDiv = baseTop !== null && $(window).scrollTop() < baseTop;

            if ($(window).scrollTop() > mapTop && !isPositionFixed && !belowBottomDiv) {
                mapContainer.css({ position: 'fixed', top: 0, height: '100vh' });

                if (baseTop === null) {
                    baseTop = mapTop;
                }

            } else if ($(window).scrollTop() > !mapTop && !isPositionFixed && !belowBottomDiv) {
                mapContainer.css({ position: 'absolute', top: 0, height: '100vh' });

                if (baseTop === null) {
                    baseTop = mapTop;
                }

            }
            else if (isPositionFixed) {
                if (aboveTopDiv) {
                    mapContainer.css({ position: 'absolute', top: 0, height: '100vh', bottom: 'auto' });
                } else if (belowBottomDiv) {
                    mapContainer.css({ position: 'absolute', top: 'auto', height: '100vh', bottom: 0 });
                }
            } else if (!isPositionFixed) {
                if (aboveTopDiv) {
                    mapContainer.css({ position: 'absolute', top: 0, height: '100vh', bottom: 'auto' });
                }
            }
        });

        // Hide Map Button
        const cardWrapper = document.getElementById('CardWrapper');
        const houseAndLandContainer = document.getElementById('house-and-land-container');
        const mapWrapper = document.getElementById('MapWrapper');
        const hideMapBtn = document.getElementById('HideMapBtn');

        $(hideMapBtn).click(function () {
            if (hideMapBtn.classList.contains("map-hidden")) {
                hideMapBtn.innerHTML = "Hide Map";
                mapWrapper.classList.remove("uk-hidden");
                hideMapBtn.classList.remove("map-hidden");
                cardWrapper.classList.add("uk-width-1-2@s", "uk-width-2-5@m", "uk-width-2-3@l");
                houseAndLandContainer.classList.remove("uk-child-width-1-2@s", "uk-child-width-1-3@l");
                houseAndLandContainer.classList.add("uk-child-width-1-2@l");


            } else {
                hideMapBtn.innerHTML = "Show Map";
                mapWrapper.classList.add("uk-hidden");
                hideMapBtn.classList.add("map-hidden");
                cardWrapper.classList.remove("uk-width-1-2@s", "uk-width-2-5@m", "uk-width-2-3@l");
                houseAndLandContainer.classList.remove("uk-child-width-1-2@l");
                houseAndLandContainer.classList.add("uk-child-width-1-2@s", "uk-child-width-1-3@l");
            }
        })
    }
});

const { functions } = require('lodash');
const displayHomeMarker = require('../../images/homegroup/display_home_marker.png');
//
// Map Marker Object Controller
//-----------------------------
window.DisplayHomesPageObject = function(opts) {
    var displayhomespage_obj = $.extend(new window.PageObject({}), {
        map: false,
        markerElements: false,
        mapMarkers: [],
        markerBounds: new google.maps.LatLngBounds(),
        bouncingMarker: false,
        markerWasClicked: false,
        activeInfoWindow: null,
        setupMap: function() {
            var self = this;

            var mapOptions = {
                zoom: opts.mapZoomLevel,
                center: new google.maps.LatLng(-32.039, 115.843),
                mapTypeControl: false,
                panControl: false,
                scaleControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.LARGE,
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                },
                streetViewControl: true,
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                }
            };

            const mapDiv = document.getElementById('display-homes-map');
            if (mapDiv) {
                this.map = new google.maps.Map(mapDiv, mapOptions);

                this.markerElements = $('.display-homes-card');

                if (this.markerElements.length) {
                    this.markerElements.each(function() {
                        var latitude = $(this).data('lat');
                        var longitude = $(this).data('lng');
                        var title = $(this).data('title');
                        var itemID = $(this).data('itemid');
                        var previewLink = $(this).data('preview-link');
                        var estate = $(this).data('estate');
                        var address1 = $(this).data('address1');
                        var address2 = $(this).data('address2');
                        var storeys = ($(this).data('storeys') === 1 ? 'Single' : 'Double') + ' Storey';
                        var width = $(this).data('width') + 'm';
                        var frontage = $(this).data('frontage') + 'm';
                        var bedrooms = $(this).data('bedrooms');
                        var bathrooms = $(this).data('bathrooms');
                        var carports = $(this).data('carports');
                        var directions = $(this).data('directions');
                        var construction = $(this).data('construction');

                        var pos = new google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));
                        var marker = new google.maps.Marker({
                            position: pos,
                            map: self.map,
                            title: title,
                            animation: google.maps.Animation.DROP,
                            contentID: itemID
                        });

                        marker.setIcon(displayHomeMarker);

                        var address = address1 ? address1 + ', <br>' + address2 : address2;

                        if (construction) {
                            // Hide address if home is under construction
                            var constructionAddress = '';
                        } else {
                            var constructionAddress = '<p class="full-address">' + address + '</p>' +
                                '</div>' +
                                '<div class="directions">' +
                                '<a class="directions-btn" href=' + directions + '> Directions </a>';
                        }

                        const popUpContent =
                            '<div id="content" class="popup-map-content">' +
                            '<h4 class="title">' + title + '</h4>' +
                            '<div class="address-box">' +
                                '<div class="address">' +
                                '<p class="estate"><b>' + estate + '</b></p>' +
                                constructionAddress +
                                '</div>' +
                            '</div>' +

                            '<div class="details-box">' +
                                '<div class="single-detail width-size">' +
                                    '<img data-src="/output/svg/icon-home-frontage.svg" class="uk-preserve" uk-svg />' +
                                    '<span class="value width">' + frontage + '</span>' +
                                '</div>' +
                                '<div class="single-detail width-size">' +
                                    '<img data-src="/output/svg/icon-home-bedrooms.svg" class="uk-preserve" uk-svg />' +
                                    '<span class="value bedrooms">' + bedrooms + '</span>' +
                                '</div>' +
                                '<div class="single-detail width-size">' +
                                    '<img data-src="/output/svg/icon-home-bathrooms.svg" class="uk-preserve" uk-svg />' +
                                    '<span class="value bathrooms">' + bathrooms + '</span>' +
                                '</div>' +
                                '<div class="single-detail width-size">' +
                                    '<img data-src="/output/svg/icon-home-carparks.svg" class="uk-preserve" uk-svg />' +
                                    '<span class="value carports">' + carports + '</span>' +
                                '</div>' +
                            '</div>' +

                            '<div class="actions-container">' +
                                '<div class="left storeys-container">' +
                                    '<span class="storeys">' + storeys + '</span>' +
                                '</div>' +
                                '<div class="right view-home-container">' +
                                    '<a class="view-home-link" href=' + previewLink + '> View Home <img style="margin-left:4px;" data-src="/output/svg/icon-home-view.svg" class="uk-preserve" uk-svg /></a>' +
                                '</div>' +
                            '</div>' +
                            '</div>';

                        var infowindow = new google.maps.InfoWindow({
                            content: popUpContent
                        });

                        self.mapMarkers.push(marker);
                        self.markerBounds.extend(pos);

                            google.maps.event.addListener(marker, 'click', function() {

                                if (self.activeInfoWindow) {
                                    self.activeInfoWindow.close();
                                }

                                self.activateMarker(marker, marker.content, true);
                                self.markerWasClicked = true;

                                infowindow.open(self.map, marker);
                                self.activeInfoWindow = infowindow;

                                setTimeout(function() {
                                    let popupWidget = document.querySelector('.gm-style-iw-t');
                                    let popupWidgetContainer = document.querySelector('.gm-style-iw');
                                    let closePopupButton = document.querySelector('.gm-ui-hover-effect');

                                    popupWidget.classList.add('gmap-single-popup-widget');
                                    popupWidgetContainer.classList.add('gmap-single-popup-widget-container');
                                    closePopupButton.classList.add('gmap-close-widget-btn');
                                }, 1);

                            });

                        google.maps.event.addListener(
                            marker,
                            'mouseover',
                            self.debounce(function(e) {
                                e.stop();

                                if (!self.markerWasClicked) {
                                    self.activateMarker(marker, marker.content, false);
                                }
                            }, 320)
                        );
                    });

                    // Add a marker clusterer to manage the markers.
                    var markerCluster = new markerClusterer(this.map, this.mapMarkers, {
                        styles: [
                            {
                                url: displayHomeMarker,
                                height: '59',
                                width: '44',
                                textColor: '#333',
                                lineHeight: '46'
                            }
                        ]
                    });
                    markerCluster.setCalculator(function(markers, numStyles) {
                        var index = 0,
                            count = markers.length,
                            dv = count,
                            result = {};
                        while (dv > 0) {
                            dv = parseInt(dv - 5, 10);
                            index++;
                        }
                        index = Math.min(index, numStyles);
                        result = {
                            text: '<div class="marker-counter">' + count + '</div>',
                            index: index
                        };
                        return result;
                    });

                    google.maps.event.addListenerOnce(this.map, 'idle', function() {
                        self.map.fitBounds(self.markerBounds);
                        if (self.mapMarkers.length < 2) {
                            self.map.setZoom(14);
                        } else if (opts.mapZoomLevel > 0) {
                            self.map.setZoom(opts.mapZoomLevel);
                        }
                    });
                }
            }
        },

        activateMarker: function(marker, content, bounce) {
            var self = this;

            if (bounce) {
                if (this.bouncingMarker && self.bouncingMarker !== marker) {
                    this.bouncingMarker.setAnimation(null);
                }

                if (marker.getAnimation() != null) {
                    marker.setAnimation(null);
                    this.bouncingMarker = false;
                } else {
                    marker.setAnimation(google.maps.Animation.BOUNCE);
                    this.bouncingMarker = marker;
                    setTimeout(function() {
                        if (self.bouncingMarker) {
                            self.bouncingMarker.setAnimation(null);
                        }
                    }, 5000);
                }
            }
        },

        debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this,
                    args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },

        onReady: function() {
            this.setupMap();
        }
    });

    if (opts) {
        return $.extend(displayhomespage_obj, opts);
    } else {
        return displayhomespage_obj;
    }
};